export default "__VITE_ASSET__BsRI02H1__"